module.exports = __webpack_public_path__ + "img/house-nation.32438912.png";